export default {
    common: {
        email: '電郵',
        LoginBtn: '登錄',
        SignUpBtn: '註冊',
        SubmitBtn: '提交',
        ExitBtn: '退出',
        LogoutBtn: '登出'
    },
    login: {},
    login2FA: {
        pleaseCheckEmail: '請於電郵內查收驗證碼',
        VerificationCode: '驗證碼'
    },
    header: {
        OrderHistory: '訂單記錄',
        MYACCOUNT: '我的賬戶',
        WelcomeBack: '歡迎回來'
    },
    detail: {
        TotalOrders: '訂單總數',
        TotalProducts: '產品總數',
        WonderlandPoints: 'Wonderland積分',
        APMCredits: 'APM積分',
        ExpireOn: '有效期限',
        NoAPMCredits: '暫無APM積分',
        CreditsLoading: '積分加載中'
    },
    panel: {},
    entry: {
        Client: '顧客',
        OrderDate: '訂單日期',
        DeliverDate: '送達日期',
        Description: '描述',
        Total: '合計'
    },
    board: {
        Order: '訂單',
        Date: '日期',
        Total: '合計'
    },
    order: {
        OrderID: '訂單編號',
        PurchasePlace: '購買地點',
        PurchaseDate: '下單日期',
        TotalPrice: '總價',
    },
    product: {
        Name: '商品名稱',
        SKU: '商品SKU',
        Size: '商品尺碼',
        Quantity: '商品數量',
        Price: '商品價格',
        WarrantyUntil: '保修期至',
    }
}


// WEBPACK FOOTER //
// ./src/locales/tc/index.js